import React, { Component } from 'react';
import './style.scss';

export class Draggable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    var pos1 = 0,
      pos2 = 0,
      pos3 = 0,
      pos4 = 0;

    function onDragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      // call a function whenever the cursor moves:
      document.onmousemove = onElementDrag.bind(this);
      document.onmouseup = onCloseDragElement.bind(this);
    }

    function onCloseDragElement(e) {
      this.draggable.onmouseup = null;
      document.onmousemove = null;
      this.props.onDragEnd({
        topPx: this.draggable.style.top,
        leftPx: this.draggable.style.left,
        top: parseInt(this.draggable.style.top, 10),
        left: parseInt(this.draggable.style.left, 10),
      });
    }

    function onElementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
    // TODO: Add boundary check   if(){
        this.draggable.style.top = this.draggable.offsetTop - pos2 + 'px';
        this.draggable.style.left = this.draggable.offsetLeft - pos1 + 'px';
    //   }

    }

    this.draggable.onmousedown = onDragMouseDown.bind(this);
  }

  componentWillUnmount() {
    this.draggable.onmousedown = null;
    document.onmouseup = null;
  }

  render() {
    const { top, left, id, children, height, width, disableDrag = false } = this.props;
    return (
      <div
        key={id}
        ref={(ref) => {
          this.draggable = ref;
        }}
        className={'draggable'}
        style={{
          position: 'absolute',
          top: `${top}px`,
          left: `${left}px`,
          height: `${height}px`,
          width: `${width}px`,
          pointerEvents: `${disableDrag ? 'none' : 'initial'}`,
        }}>
        {children}
        <div className={'dragger'} />
      </div>
    );
  }
}
